import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DriverProdSupportComponent } from './driver-prod-support/driver-prod-support.component';
import { SharedUiFleetoperateToolbarModule } from '@fleetoperate/shared/ui/fleetoperate-toolbar';
import { SharedUiHeaderModule } from '@fleetoperate/shared/ui/header';
import { SharedUiOverlayModule } from '@fleetoperate/shared/ui/overlay';
import { ErrorsModule } from '@fleetoperate/delivery-recruiter/feature-errors';
import { MatRadioModule, MatButtonModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [DriverProdSupportComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MatButtonModule,
    MatRadioModule,
    ErrorsModule,
    SharedUiFleetoperateToolbarModule,
    SharedUiHeaderModule,
    SharedUiOverlayModule
  ]
})
export class DriverProdSupportModule {}
